<template>
  <div id="app" class="body-container" :class="{ 'ok-bao': $tools.isOKbao() || $tools.isOKTX() }">
    <keep-alive :include="include">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <div v-show="loading" class="lz-readys" id="lz-readys">
      <div class="spinner">
        <div class="spinner-container container1">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container2">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container3">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require("static/css/animate.min.css");
require("@static/iconfont/iconfont.css");
import common from "./api/common";
export default {
  name: "App",
  data() {
    return {
      loading: false,
      appLoad: false, //app api是否就绪
      user: {},
      include: [],//需要被缓存的页面数组
      userInfo: JSON.parse(localStorage.getItem('jzy_user') || '{}')
    };
  },
  created() { },
  watch: {
    $route(to, from) {
      //如果需要缓存 且 将name push 进 includes数组
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
      }
      //如果上一个页面需要缓存 且 是返回上一级页面 则删除该页面缓存
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        let idx = this.include.findIndex(i => i == from.name);
        idx !== -1 && this.include.splice(idx, 1);
      }
    }
  },
  methods: {
    setToken() {
      if (this.$route.query.token) {
        localStorage.jzy_token = this.$route.query.token;
      }
    }
  },
  beforeCreate() {
    this.$router.onReady(() => {
      this.setToken && this.setToken();
    });
  },
  mounted() {
    // // 判断浏览器种类
    // if (
    //   /ip(hone|od|ad).*(micromessenger|mqqbrowser)/i.test(navigator.userAgent)
    // ) {
    //   // 冒泡监听失去焦点事件 blur不会冒泡
    //   window.addEventListener("focusout", function (e) {
    //     // 判断元素
    //     if (e.target && /(input|select|textarea)/i.test(e.target.tagName)) {
    //       document.body.scrollTop = document.body.scrollTop; // 滚动页面
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss">
@import "./sass/common_ok.scss";//ok保专属样式
#app {
  width: 100%;
  max-width: 10rem;
  min-height: 100%;
  margin: 0 auto;
  overflow: hidden;
}
</style>
